import { ConsentActionDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { ConsentAction } from '@/services/graphql/types';

export const mapperConsentActionDataEnum = createEnumMapperFunction(
  ConsentAction,
  ConsentActionDataEnum
);
